export default __webpack_public_path__ + "static/media/Boots of the Revelations.704bd157.jpg";